'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = require('../../components');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
var DeletePropertyModal = function (_Component) {_inherits(DeletePropertyModal, _Component);function DeletePropertyModal() {var _temp, _this, _ret;_classCallCheck(this, DeletePropertyModal);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      val: '',
      hasError: false,
      reason: '' }, _this.


    handleSubmit = function (evt) {
      evt.preventDefault();var _this$state =
      _this.state,val = _this$state.val,reason = _this$state.reason;
      if (!_this.state.val || val === 'other' && !reason) {
        return _this.setState({ hasError: true });
      }

      return _this.props.handleSubmit({ option: val, answer: reason });
    }, _temp), _possibleConstructorReturn(_this, _ret);}DeletePropertyModal.prototype.

  render = function render() {var _this2 = this;var _props =










    this.props,isOpen = _props.isOpen,hideDeleteModal = _props.hideDeleteModal,deleteOptions = _props.deleteOptions,headerText = _props.headerText,selectPlaceholder = _props.selectPlaceholder,inputPlaceholder = _props.inputPlaceholder,errorText = _props.errorText,deleteButtonText = _props.deleteButtonText,cancelButtonText = _props.cancelButtonText;

    if (!isOpen) {
      return null;
    }

    return (
      _react2.default.createElement(_components.Modal, {
          className: 'deletePropertyModal',
          isOpen: isOpen,
          onRequestClose: hideDeleteModal,
          isCloseButtonInvisible: true },

        _react2.default.createElement('form', {
            name: 'deletePropertyForm',
            onSubmit: this.handleSubmit,
            className: this.state.val === 'other' ? 'extended' : null },

          _react2.default.createElement('p', null, headerText),
          _react2.default.createElement(_components.OMGenericSelect, {
            options: deleteOptions,
            value: this.state.val,
            onChange: function onChange(val) {_this2.setState({ val: val, hasError: false, reason: '' });},
            placeholder: selectPlaceholder.toString() }),

          this.state.val === 'other' ?
          _react2.default.createElement('input', {
            type: 'text',
            value: this.state.reason,
            onChange: function onChange(evt) {return _this2.setState({ reason: evt.target.value, hasError: false });},
            placeholder: inputPlaceholder }) :

          null,

          _react2.default.createElement('p', { className: 'errorMessage' }, this.state.hasError ? errorText : ''),

          _react2.default.createElement('div', null,
            _react2.default.createElement('button', { className: 'btn btn-primary', type: 'submit' }, deleteButtonText),
            _react2.default.createElement('button', { className: 'btn btn-default', onClick: hideDeleteModal }, cancelButtonText)))));




  };return DeletePropertyModal;}(_react.Component);


DeletePropertyModal.propTypes = {
  isOpen: _propTypes2.default.bool,
  hideDeleteModal: _propTypes2.default.func,
  deleteOptions: _propTypes2.default.array,
  headerText: _propTypes2.default.func,
  selectPlaceholder: _propTypes2.default.func,
  inputPlaceholder: _propTypes2.default.func,
  errorText: _propTypes2.default.func,
  handleSubmit: _propTypes2.default.func,
  deleteButtonText: _propTypes2.default.func,
  cancelButtonText: _propTypes2.default.func };exports.default =


DeletePropertyModal;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/DeletePropertyModal/DeletePropertyModal.js
// module id = 2653
// module chunks = 0